import {GUEST_DETAILS_REGISTERED_STATUSES, GUEST_STATUSES} from './constants';

function isGuestVerificationPendingStatus(status?: GUEST_STATUSES | null) {
  return status === GUEST_STATUSES.verification_pending;
}

function isGuestFullyRegisteredStatus(status?: GUEST_STATUSES | null) {
  return status === GUEST_STATUSES.complete;
}

function isGuestDetailsRegisteredStatus(status?: GUEST_STATUSES | null) {
  return GUEST_DETAILS_REGISTERED_STATUSES.includes(status as GUEST_STATUSES);
}

function isGuestIncompleteStatus(status?: GUEST_STATUSES | null) {
  return !isGuestDetailsRegisteredStatus(status);
}

export {
  isGuestVerificationPendingStatus,
  isGuestFullyRegisteredStatus,
  isGuestDetailsRegisteredStatus,
  isGuestIncompleteStatus,
};
